import * as React from 'react';
import { ButtonStyled, LinkStyled } from './styled';
import { ButtonVariant, ButtonSize } from '../../types/types';
import { ButtonProps as CoreButtonProps } from '../../types/interfaces/buttonInterface';

type Props = Omit<CoreButtonProps, 'size' | 'variant'> & {
  // accept both old and new props
  variant?: ButtonVariant;
  size?: ButtonSize;

  phVariant?: ButtonVariant;
  phSize?: ButtonSize;

  processing?: boolean;
  innerText?: React.ReactNode;
  renderAsLink?: boolean;
  className?: string;
  style?: React.CSSProperties;
  href?: string;
  target?: string;
};

export const Button: React.FC<Props> = ({
  innerText,
  renderAsLink = false,
  variant,
  size,
  phVariant,
  phSize,
  processing,
  style,
  className,
  href,
  target,
  ...rest
}) => {
  // map legacy -> new
  const effVariant = phVariant ?? variant;
  const effSize = phSize ?? size;

  if (renderAsLink) {
    return (
      <LinkStyled
        href={href}
        target={target}
        phVariant={effVariant}
        phSize={effSize}
        processing={processing}
        className={className}
        style={style}
        {...rest}
      >
        {innerText}
      </LinkStyled>
    );
  }

  return (
    <ButtonStyled
      phVariant={effVariant}
      phSize={effSize}
      processing={processing}
      className={className}
      style={style}
      {...rest}
    >
      {innerText}
    </ButtonStyled>
  );
};
